import { AxiosResponse } from 'axios';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { getUserRolesApi } from 'services/openClaimService';
import { ApiResponse } from 'types/ApiResponse';
import { setRoleList } from './actions';
import { ROLES_TYPES } from './types';

export function* setRoleListSaga() {
  try {
    const { data }: AxiosResponse<ApiResponse<any>> = yield call(
      getUserRolesApi,
    );

    yield put(setRoleList(data.response.roles.map(role => role.toUpperCase())));
  } catch (err) {
    console.log(err);
  }
}

export default all([
  takeLatest(ROLES_TYPES.GET_ROLELIST_REQUEST, setRoleListSaga),
]);
